export const ROLES = {
    ADMIN: 'ADMIN',
    FINANCE: 'FINANCE',
    TEAM: 'TEAM',
    VENDOR: 'VENDOR',
    DIRECTOR: 'DIRECTOR',
    PACKER: 'PACKER'
}

export const ALL_ROLES = Object.values(ROLES).filter(role => role !== ROLES.PACKER)

export const ROUTES = {
    NOTIFICATIONS_SETTINGS: '/settings/notifications',
    NOTIFICATIONS: '/notifications',
    DEMAND_PLANNING: '/demand-planning',
    MERCHANDISING_KPIS: '/merchandising-kpis',
    FINANCE: '/finance',
    SHIPPING: '/shipping',
    CATALOG: '/catalog',
    FORECAST_PLANNING_SYSTEM: '/forecast-planning-system',
    PRODUCTS: '/inventory/products',
    PRINT_SETTINGS: '/settings/print-label-settings',
    BUDGET_SETTINGS: '/settings/budget-settings',
    USERS_SETTINGS: '/settings/users-settings',
    EFFECTIVE_CAPITAL_SUMMARY: '/effective-capital-summary',
    THIRTEEN_WEEK_CASH_FLOW: '/thirteen-week-cash-flow',
    VENDORS: '/vendors/list',
    BOM: '/bom',
    INVENTORY_RECLASSIFY: '/inventory-reclassify',
    CREATE_VENDOR: '/vendors/create-vendor',
    DUPLICATES: '/duplicates',
    EXISTED_SKUS: '/existed-skus',
    INACTIVE_SKUS_COMPARISON: '/inactive-skus-comparison',
    VENDOR_VIEW: '/vendors/view/:id',
    SKU_MAPPING: '/sku-mapping',
    CRON: '/cron',
    NOTES: '/notes',
    KLAVIYO_ANALYTICS: '/klaviyo-analytics',
    TRYBE_CONTEST: '/trybe-contest',
    QB_REPORT: '/quickbooks-report',
    BUDGET: "/budget",
    FORECAST: "/forecast",
    PROFIT_AND_LOSS: '/profit-and-loss-report',
    BALANCE_SHEET: '/balance-sheet-report',
    CASH_FLOW: '/cash-flow-report',
    COGS_CANONICAL_VIEW: '/cogs-canonical-view',
    PRODUCTS_CATALOG: '/products-catalog',
    FINANCE_CHAT: '/finance-chat',
    MEC_CLOSE_CHECKLIST: '/mec-close-checklist',
    BUDGET_X_FORECAST: '/budget-x-forecast',
    DISCONNECT_QB: '/disconnect-quickbooks',
    OPEN_TO_BUY: '/open-to-buy',
    DEMAND_DESTRIBUTION_PROFILE: '/demand-destributon-profile',
    INVENTORY_ON_HAND: '/inventory-on-hand',
    INVENTORY_SELL_OUT_DAYS: '/inventory-sellout-days',
    SHOPIFY_AMAZON_INVENTORY: '/inventory-overview',
    SHOPIFY_AMAZON_INVENTORY_CALCULATION: '/stock-levels-calculation',
    PURCHASE_ORDERS: '/purchase-orders',
    ORDERS: '/orders',
    RECEIVED: '/received',
    RECEIVED_LOG: '/received_log',
    RECEIVED_SESSIONS: '/received-sessions',
    WAREHOUSE: '/location-master',
    INVENTORY_LEDGER: '/inventory-ledger',
    FBA_TRANSFERS: '/fba-transfers',
    AMAZON_FBA_INVENTORY: '/amazon-fba-inventory',
    INVENTORY_TRANSFERS: '/inventory-transfers',
    RETURNS_RECEIVING: '/returns-receiving',
    WAREHOUSE_LEGACY: '/warehouse',
    REPORTS: '/report',
    REPORTS_CUSTOM: '/report/custom/:customReportId',
    REPORTS_SALES_BY_PRODUCT: '/report/sales-by-product',
    REPORTS_SALES_BY_PRODUCT_BY_DAY: '/report/sales-by-product-by-day',
    REPORTS_PAYMENT: '/report/monthly-ap-po-paid',
    REPORTS_BILLCOM_PO_RECONCILIATION: '/report/billcom-po-reconciliation',
    REPORTS_BILLCOM_PO_BALANCE_RECONCILIATION: '/report/billcom-po-balance-reconciliation',
    REPORTS_MONTH_END_INVENTORY: '/report/month-end-inventory',
    REPORTS_PO_LEDGER_SHADOW: '/report/po-ledger-shadow',
    REPORTS_PO_STATUS_AUDIT: '/report/po-status-audit',
    REPORTS_CLOSED_PO_RECONCILIATION: '/report/closed-po-reconciliation',
    REPORTS_BILLCOM_AP_WRITEBACK_STATUS: '/report/billcom-ap-writeback-status',
    REPORTS_BILLCOM_BANK_CASH_RECON: '/report/billcom-bank-cash-recon',
    REPORTS_SALES_REVENUE: '/report/sales-revenue',
    REPORTS_SALES_REVENUE_MONTHLY: '/report/sales-revenue-monthly',
    REPORTS_SHOPIFY_PROFIT_SUMMARY: '/report/shopify-profit-summary',
    REPORTS_SHOPIFY_PROFIT_BY_SKU_SUMMARY: '/report/shopify-profit-by-sku-summary',
    REPORTS_AMAZON_PROFIT_SUMMARY: '/report/amazon-profit-summary',
    REPORTS_AMAZON_PROFIT_BY_SKU_SUMMARY: '/report/amazon-profit-by-sku-summary',
    REPORTS_MONTHLY_PO_AP_DUE: '/report/monthly-po-ap-due',
    REPORTS_MONTHLY_PO_AP_PROGRESS: '/report/monthly-po-ap-progress',
    REPORTS_INBOUND_SHIPMENTS: '/report/inbound-shipments',
    REPORTS_INBOUND_SHIPMENTS_OVERVIEW: '/report/inbound-shipments-overview',
    REPORTS_MONTHLY_INBOUND_SHIPMENTS_VALUES: '/report/received-inventory-value',
    REPORTS_RECEIVED_SHIPMENTS_REPORTS: '/report/received-shipments-reports',
    REPORTS_WAREHOUSE_INVENTORY_VALUE: '/report/warehouse-inventory-value',
    REPORTS_WAREHOUSE_RECONCILIATION: '/report/warehouse-reconciliation',
    REPORTS_BIN_RESTOCKING: '/report/bin-restocking',
    REPORTS_PICK_PACK: '/report/pick-pack',
    REPORTS_INBOUND_GET_READY: '/report/inbound-get-ready',
    REPORTS_INBOUND_RECEIVING_PUTAWAY: '/report/inbound-receiving-putaway',
    REPORTS_RETURNS_PROCESSING: '/report/returns-processing',
    REPORTS_INVENTORY_COST_CHANGE: '/report/inventory-cost-change',
    REPORTS_SHIPPING_EACH_COST_CHANGE: '/report/shipping-each-cost-change',
    REPORTS_FEDEX_BILLING_RECONCILIATION: '/report/fedex-billing-reconciliation',
    REPORTS_SHIPHERO_LABEL_COST: '/report/shiphero-label-cost',
    REPORTS_PACKAGING_USAGE: '/report/packaging-usage',
    REPORTS_QBO_CHANGE_LEDGER: '/report/qbo-change-ledger',
    REPORTS_INVENTORY_LEDGER: '/report/inventory-ledger',
    REPORTS_AMAZON_FBA_TRANSFER_LEDGER: '/report/amazon-fba-transfer-ledger',
    REPORTS_AMAZON_FBA_TRANSFER_HISTORY: '/report/amazon-fba-transfer-history',
    REPORTS_DEMAND_PLANNING_CHANGE_LOG: '/report/demand-planning-change-log',
    REPORTS_DAILY_CHANNEL_METRICS: '/report/daily-channel-metrics',
    REPORTS_DAILY_SUMMARY: '/report/daily-summary',
    REPORTS_SKU_ALLOCATION_CHANGE_LOG: '/report/sku-allocation-change-log',
    REPORTS_MISSING_INVENTORY_COST: '/report/missing-inventory-cost',
    REPORTS_SOURCE_SKUS_BY_PRODUCT: '/report/source-skus-by-product',
    REPORTS_MAX_DISCOUNT_PRICING: '/report/max-discount-pricing',
    REPORTS_EADIN_COGS: '/report/eadin-cogs',
    REPORTS_EADIN_CATALOG: '/report/eadin-catalog',
    REPORTS_EADIN_INVENTORY: '/report/eadin-inventory',
    REPORTS_BOM_PACKAGING: '/report/bom-packaging',
    REPORTS_LOW_STOCK_ALERTS: '/report/low-stock-alerts',
    REPORTS_AMAZON_FBA_LOW_STOCK_ALERTS: '/report/amazon-fba-low-stock-alerts',
    REPORTS_LOW_STOCK_SOLD_OUT_ALERTS: '/report/low-stock-sold-out-alerts',
    REPORTS_RECENT_POS: '/report/recent-pos',
    REPORTS_META_INSIGHTS: '/report/meta-insights',
    REPORTS_META_ADS: '/report/meta-ads',
    REPORTS_DATA_RECONCILIATION: '/report/data-reconciliation',
    REPORTS_KLAVIYO_CAMPAIGNS: '/report/klaviyo_campaigns',
    REPORTS_KLAVIYO_CAMPAIGN_PERFORMANCE: '/report/klaviyo_campaign_performance',
    REPORTS_KLAVIYO_FLOWS: '/report/klaviyo_flows',
    REPORTS_KLAVIYO_FLOW_PERFORMANCE: '/report/klaviyo_flow_performance',
    REPORTS_KLAVIYO_LISTS: '/report/klaviyo_lists',
    REPORTS_KLAVIYO_SEGMENTS: '/report/klaviyo_segments',
    REPORTS_KLAVIYO_METRICS: '/report/klaviyo_metrics',
    REPORTS_KLAVIYO_METRIC_AGGREGATES: '/report/klaviyo_metric_aggregates',
    ANALYTICS_TRIPLEWHALE: '/analytics/triplewhale',
    REPORTS_TOTAL_PRODUCT_REVENUE: '/report/total-product-revenue',
    REPORTS_AMAZON_MONTH_END_CLOSE_SUMMARY: '/report/amazon-month-end-close-summary',
    AMAZON_RAW_INSPECT: '/amazon-raw-inspect',
    REPORTS_AMAZON_IMPORTS: '/report/amazon-imports',
    REPORTS_AMAZON_TRANSACTION_DETAIL: '/report/amazon-transaction-detail',
    REPORTS_AMAZON_PL_SUMMARY: '/report/amazon-pl-summary',
    REPORTS_AMAZON_AD_SPEND_DETAIL: '/report/amazon-ad-spend-detail',
    REPORTS_AMAZON_RECONCILIATION_EXCEPTIONS: '/report/amazon-reconciliation-exceptions',
    API_AMAZON_RECONCILIATION_EXCEPTIONS: '/api/v1/reports/amazon-reconciliation-exceptions',
}

const ASCENDING = 'ASC';
const DESCENDING = 'DESC';

export const SORT_DIRECTION = {
    ASCENDING: ASCENDING,
    DESCENDING: DESCENDING
};

export const inventoryTableSettings = [
    {
      label: 'Product',
      value: 'product_line',
      enableSorting: true
    },
    {
      label: 'Status',
      value: 'status',
      enableSorting: false
    },
    {
      label: 'On Hand',
      value: 'on_hand',
      enableSorting: true
    },
    {
      label: 'On Order',
      value: 'on_order',
      enableSorting: true
    },
    {
      label: 'Days Of Stock',
      value: 'warehouse_days_of_stock',
      enableSorting: true
    },
    {
      label: 'Sellout Date',
      value: 'warehouse_sell_out_date',
      enableSorting: true
    },
    {
      label: '30d',
      value: 'sales_last_30',
      enableSorting: true,
      isOptional: true
    },
    {
      label: '90d',
      value: 'sales_last_90',
      enableSorting: true,
      isOptional: true
    },
    {
      label: '365d',
      value: 'sales_last_365',
      enableSorting: true,
      isOptional: true
    },
    {
      label: 'Daily Avg',
      value: 'sales_daily_avg',
      enableSorting: true,
      isOptional: true
    },
    {
      label: 'Extra Ordered',
      value: 'extra_ordered',
      enableSorting: false
    },
    {
      label: 'Total Days Of Stock',
      value: 'days_of_stock',
      enableSorting: true
    },
    {
      label: 'Sellout Date',
      value: 'sell_out_date',
      enableSorting: true
    },
    {
      label: 'Reorder Deadline',
      value: 'reorder_deadline',
      enableSorting: true
    },
    {
      label: 'Reorder Quantity',
      value: 'reorder_quantity',
      enableSorting: true
    },
    {
      label: 'Stock Arrives On',
      value: 'stock_arrives_on',
      enableSorting: true
    },
    {
      label: '180d Sellout',
      value: 'sell_out_180_days',
      enableSorting: false
    }
];

export const inventoryCalculationTableSettings = [
  {
    label: 'Product',
    value: 'product_line',
    enableSorting: true
  },
  {
    label: 'On Hand',
    value: 'on_hand',
    enableSorting: true
  },
  {
    label: 'On Order',
    value: 'on_order',
    enableSorting: true
  },
  {
    label: 'Days Of Stock',
    value: 'warehouse_days_of_stock',
    enableSorting: true
  },
  {
    label: 'Sellout Date',
    value: 'warehouse_sell_out_date',
    enableSorting: true
  },
  {
    label: '30d',
    value: 'sales_last_30',
    enableSorting: true,
    isOptional: true
  },
  {
    label: '90d',
    value: 'sales_last_90',
    enableSorting: true,
    isOptional: true
  },
  {
    label: '365d',
    value: 'sales_last_365',
    enableSorting: true,
    isOptional: true
  },
  {
    label: 'Daily Avg',
    value: 'sales_daily_avg',
    enableSorting: true,
    isOptional: true
  },
  {
    label: 'Extra Ordered',
    value: 'extra_ordered',
    enableSorting: false
  },
  {
    label: 'Total Days',
    value: 'days_of_stock',
    enableSorting: true
  },
  {
    label: 'Sellout Date',
    value: 'sell_out_date',
    enableSorting: true
  },
  {
    label: 'Reorder Deadline',
    value: 'reorder_deadline',
    enableSorting: true
  },
  {
    label: 'Reorder Quantity',
    value: 'reorder_quantity',
    enableSorting: true
  },
  {
    label: 'Stock Arrives On',
    value: 'stock_arrives_on',
    enableSorting: true
  },
  {
    label: '180d Sellout',
    value: 'sell_out_180_days',
    enableSorting: false
  }
];